<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
      <div slot="waitDeal" slot-scope="prop">
        <el-checkbox
          label="待我处理"
          name="type"
          v-model="prop.form.waitDeal"
        />
      </div>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        busiTypeOptions: [], // 业务类型
        isNeedBillOptions: [], // 票据类型
        verificationStateOptions: [], // 打款状态
        orgIdOptions: [], // 费用归属
        busiIdOptions: [], // 业务类型
        form: [
          { // 待我处理
            label: '待我处理',
            value: 'waitDeal',
            default: true,
            slot: true,
          },
          { // 业务方
            label: '业务方',
            value: 'userName',
            type: 'input',
            placeholder: '请输入业务方',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 业务单号
            label: '业务单号',
            value: 'busiCode',
            type: 'input',
            placeholder: '请输入业务单号',
          },
          { // 票据类型
            label: '票据类型',
            value: 'isNeedBill',
            type: 'select',
            default: -1,
            placeholder: '请选择票据类型',
          },
          { // 打款状态
            label: '打款状态',
            value: 'verificationState',
            type: 'select',
            default: -1,
            placeholder: '请选择打款状态',
          },
          { // 费用归属
            label: '费用归属',
            value: 'orgId',
            type: 'select',
            default: -1,
            placeholder: '请选择费用归属',
          },
          { // 应付时间
            label: '应付时间',
            value: 'Time',
            type: 'date',
            default: [],
            placeholder: '请选择应付时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 核销时间
            label: '核销时间',
            value: 'verificationTime',
            type: 'date',
            default: [],
            placeholder: '请选择核销时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 发车时间
            label: '发车时间',
            value: 'dependTime',
            type: 'date',
            default: [],
            placeholder: '请选择发车时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 客户名称
            label: '客户名称',
            value: 'customName',
            type: 'input',
            placeholder: '请输入客户名称',
          },
          { // 线路名称
            label: '线路名称',
            value: 'sourceName',
            type: 'input',
            placeholder: '请输入线路名称',
          },
          { // 代收名称
            label: '代收名称',
            value: 'collectionUserName',
            type: 'input',
            placeholder: '请输入代收名称',
          },
          { // 订单备注
            label: '订单备注',
            value: 'orderRemark',
            type: 'input',
            placeholder: '请输入订单备注',
          },
          { // 收票主体
            label: '收票主体',
            value: 'billLookUp',
            type: 'input',
            placeholder: '请输入收票主体',
          },
          { // 业务类型
            label: '业务类型',
            value: 'busiId',
            type: 'select',
            default: -1,
            placeholder: '请选择业务类型',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 应付时间
      if (searchBoxData.Time && searchBoxData.Time[0]) {
        searchBoxData.startTime = this.formatDate(searchBoxData.Time[0], 1);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1], 1);
      }
      delete searchBoxData.Time;
      // 核销时间
      if (searchBoxData.verificationTime && searchBoxData.verificationTime[0]) {
        searchBoxData.verificationStartTime = this.formatDate(searchBoxData.verificationTime[0], 1);
        searchBoxData.verificationEndTime = this.formatDate(searchBoxData.verificationTime[1], 1);
      }
      delete searchBoxData.verificationTime;
      // 发车时间
      if (searchBoxData.dependTime && searchBoxData.dependTime[0]) {
        searchBoxData.dependTimeStart = this.formatDate(searchBoxData.dependTime[0], 1);
        searchBoxData.dependTimeEnd = this.formatDate(searchBoxData.dependTime[1], 1);
      }
      delete searchBoxData.dependTime;
      this.$refs.tableBox.saveSearchBoxData({
        _GRID_TYPE: 'jq',
        ...searchBoxData,
      });
    },
  },
  async created () {
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...await getDepartmentAllList(),
    ];
    const enumsList = await getEnumList({
      codeType: 'BUSINESS_NUMBER_TYPE,FUNDS_IS_NEED_BILL,APP_BSUBJECTS_OVERDUE,BUSINESS_NUMBER_TYPE',
    });
    this.searchBoxData.busiTypeOptions = enumsList[0]; // 业务类型
    this.searchBoxData.isNeedBillOptions = [ // 票据类型
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
    this.searchBoxData.verificationStateOptions = [ // 打款状态
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[2],
    ];
    this.searchBoxData.busiIdOptions = [ // 业务类型
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[3],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
